/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSchema } from '../../models/document-schema';

export interface ApiDocumentSchemasSchemasGet$Json$Params {
}

export function apiDocumentSchemasSchemasGet$Json(http: HttpClient, rootUrl: string, params?: ApiDocumentSchemasSchemasGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchema>>> {
  const rb = new RequestBuilder(rootUrl, apiDocumentSchemasSchemasGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentSchema>>;
    })
  );
}

apiDocumentSchemasSchemasGet$Json.PATH = '/api/DocumentSchemas/schemas';
